import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FieldInfoModeService } from './field-info-mode.service';

@Component({
  selector: 'cs-field-info-toggle',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      type="button"
      class="toggle"
      [class.toggle--on]="mode.enabled()"
      [attr.aria-pressed]="mode.enabled()"
      title="Inspecionar campos (mostra origem SQL)"
      (click)="mode.toggle()">
      <span class="toggle__icon">i</span>
      <span class="toggle__label">{{ mode.enabled() ? 'Ocultar origem' : 'Inspecionar campos' }}</span>
    </button>
  `,
  styles: [`
    .toggle {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      font-family: inherit;
      font-size: 12px;
      font-weight: 500;
      padding: 7px 12px;
      border: 1px solid rgb(var(--color-line-2));
      background: rgb(var(--color-paper));
      color: rgb(var(--color-ink-2));
      border-radius: var(--radius);
      cursor: pointer;
      transition: all 0.15s;

      &:hover {
        border-color: rgb(var(--color-ink-3));
      }

      &--on {
        background: rgb(var(--color-accent));
        border-color: rgb(var(--color-accent));
        color: rgb(var(--color-paper));
      }
    }

    .toggle__icon {
      width: 16px;
      height: 16px;
      border: 1px solid currentColor;
      border-radius: 50%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-style: italic;
      font-size: 10px;
      font-weight: 700;
    }
  `],
})
export class FieldInfoToggleComponent {
  readonly mode = inject(FieldInfoModeService);
}
